import { render } from "./CancerList.vue?vue&type=template&id=0a79702e"
import script from "./CancerList.vue?vue&type=script&lang=js"
export * from "./CancerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__